import { render, staticRenderFns } from "./AscErrorTypeIconLabel.vue?vue&type=template&id=7c87b644&"
import script from "./AscErrorTypeIconLabel.vue?vue&type=script&lang=js&"
export * from "./AscErrorTypeIconLabel.vue?vue&type=script&lang=js&"
import style0 from "./AscErrorTypeIconLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports